// Haptic feedback via the iOS native bridge (protocol §5 `ui.haptic`).
// A strict no-op outside the native app — safe to call unconditionally from
// interaction handlers. Fire-and-forget: never awaited, never throws.

import { bridge, isNativeApp } from './nativeApp';

export type HapticType = 'light' | 'medium' | 'success' | 'warning' | 'error' | 'selection';

export const haptic = (type: HapticType): void => {
  if (!isNativeApp()) return;
  void bridge.call('ui.haptic', { type }).catch(() => {
    /* haptics are best-effort */
  });
};

export default haptic;
